import React, { useMemo } from 'react';
import { AppendixUpload } from '../../../AppendixUpload';
import { TextWithTemplates } from '../../../TextWithTemplates';
import { useTranslation } from 'react-i18next';
import { resolveValidationRules } from '../../../../../../utilities/validationRuleHelper';
import { mapFileListItemToFile } from '../../../../../../utilities/mapperFunctions';
import { resolveFileExtensionFromMime } from '../../../../../../utilities/files';

const BodyInformationFieldWrite = ({
  bodyTextValue,
  files,
  templateOptions,
  onChangeText,
  onChangeFiles,
  onDownloadFile,
  validationEntity,
}) => {
  const { t: translator } = useTranslation();

  // in bytes
  const { maxFileSize, allowedFileTypes } = resolveValidationRules(
    validationEntity,
  );

  const allowedFileExtensions = useMemo(
    () =>
      allowedFileTypes?.map(resolveFileExtensionFromMime).join(', ') ||
      translator('pages.hearingDetails.allFileTypesAllowed'),
    [allowedFileTypes, translator],
  );

  const onChangeDropdown = (_, value) =>
    onChangeText((value?.content ? value.content : value.text) || '');

  const onDeleteFile = (value) =>
    value && onChangeFiles(mapFileListItemToFile(value), true);

  return (
    <div aria-label={translator('ariaLabel.bodyInformationFieldWrite')}>
      <TextWithTemplates
        textValue={bodyTextValue}
        templateOptions={templateOptions}
        onChangeDropdown={onChangeDropdown}
        onChangeText={onChangeText}
        placeHolderText={translator('global.noneSelected')}
        labelText={translator('hearingProperties.bodyInformation.text')}
      />
      <AppendixUpload
        onUploadFiles={onChangeFiles}
        maxFileSize={maxFileSize}
        fileItems={files}
        onDownloadFile={onDownloadFile}
        allowedFileTypes={allowedFileExtensions}
        onDeleteFile={onDeleteFile}
        allowMultiple={true}
        headerText={translator('hearingProperties.bodyInformation.readMore')}
      />
    </div>
  );
};

export { BodyInformationFieldWrite };
